import { loader } from 'graphql.macro'

export default function clientsAll ({ dataLoaders, queryKey }) {
  const [, haulerId] = queryKey
  const schema = loader('./clientsAll.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, { haulerId })
}
